import { render, staticRenderFns } from "./RecentVideos.vue?vue&type=template&id=b429789e&scoped=true&"
import script from "./RecentVideos.vue?vue&type=script&lang=js&"
export * from "./RecentVideos.vue?vue&type=script&lang=js&"
import style0 from "./RecentVideos.vue?vue&type=style&index=0&id=b429789e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b429789e",
  null
  
)

export default component.exports